import { IndicatorsContainerCustomProps } from '@/components/Purchases/components/SelectRegion/components/IndicatorsContainer.js';
import { CustomProps } from './types.js';
import { Styles } from './types.js';

export const styles: Styles = {
  multiValue: (base, state) => {
    const { data: option } = state;
    const { selectedItem } = (
      state.selectProps as unknown as { customProps: CustomProps }
    ).customProps;
    const isSelected = selectedItem && option === selectedItem;
    return {
      ...base,
      backgroundColor: isSelected ? '#ccdfff' : base.backgroundColor,
      cursor: 'pointer',
    };
  },
  multiValueLabel: (base) => ({
    ...base,
    maxWidth: 200,
  }),
  option: (base) => ({
    ...base,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
  }),
};
